import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AiOutlineMenu } from 'react-icons/ai'
import { setConfig } from '../../actions/config'

class ToggleLayout1 extends Component {
  constructor() {
    super()
    this.toggleLayout = this.toggleLayout.bind(this)
  }
  toggleLayout() {
    let { layout } = this.props.config
    if (layout === 'default-sidebar') {
      this.props.setConfig('layout', 'collapsed-sidebar')
    } else {
      this.props.setConfig('layout', 'default-sidebar')
    }
    this.props.setConfig('collapsed', false)
  }
  render() {
    return (
      <ul className="nav nav-inline nav-toggle-layout-1">
        <li className="nav-item">
          <div className="nav-link p-0" onClick={this.toggleLayout}>
            <AiOutlineMenu size={25} style={{ 'cursor': 'pointer' }} />
          </div>
        </li>
      </ul>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    config: state.config
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setConfig: (key, value) => dispatch(setConfig(key, value))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ToggleLayout1)
